export const styles = {
  color: {
    primary: "#332E1A",
    backgroundHeader: "#856900"
  }
}